import { useNavigate } from "react-router-dom";
import { Shell } from "../components/Layout";
import { Button } from "../components/ui/button";

export default function Landing() {
  const navigate = useNavigate();
  return (
    <Shell testid="landing-page">
      <div className="mb-12 max-w-3xl">
        <h1 className="font-head text-4xl font-semibold tracking-tight sm:text-5xl lg:text-6xl">
          SISU Centro Multidisciplinar
        </h1>
        <p className="mt-5 text-lg leading-relaxed text-ink-700 sm:text-xl">
          SISU Centro Multidisciplinar es un espacio dedicado al aprendizaje, el lenguaje y el
          desarrollo integral. Ofrecemos apoyo educativo, logopedia y atención personalizada,
          acompañando a cada alumno y a su familia según sus necesidades.
        </p>
        <p className="mt-4 text-lg text-ink-700">Seleccione el área que desea consultar.</p>
      </div>

      <div className="grid gap-8 md:grid-cols-2">
        <div
          data-testid="module-centro-card"
          className="flex flex-col justify-between rounded-2xl border-2 border-border bg-white p-8 shadow-sm transition-colors hover:border-centro"
        >
          <h2 className="font-head text-3xl font-medium">Centro de Estudios</h2>
          <Button
            data-testid="go-centro-btn"
            onClick={() => navigate("/centro")}
            className="mt-8 h-14 w-full bg-centro text-lg hover:bg-centro-hover"
          >
            Acceder a Centro de Estudios
          </Button>
        </div>

        <div
          data-testid="module-logopedia-card"
          className="flex flex-col justify-between rounded-2xl border-2 border-border bg-white p-8 shadow-sm transition-colors hover:border-logo"
        >
          <h2 className="font-head text-3xl font-medium">Logopedia</h2>
          <Button
            data-testid="go-logopedia-btn"
            onClick={() => navigate("/logopedia")}
            className="mt-8 h-14 w-full bg-logo text-lg hover:bg-logo-hover"
          >
            Acceder a Logopedia
          </Button>
        </div>
      </div>

      <div className="mt-12 rounded-2xl border border-border bg-cream p-6 sm:p-8">
        <h3 className="font-head text-2xl font-medium">¿Dispone ya de una cuenta?</h3>
        <p className="mt-2 text-lg text-ink-700">
          Con un único usuario y contraseña puede acceder tanto al Centro de Estudios como a
          Logopedia.
        </p>
        <Button
          data-testid="landing-login-btn"
          variant="outline"
          className="mt-5 h-14 text-lg"
          onClick={() => navigate("/entrar")}
        >
          Acceder a mi cuenta
        </Button>
      </div>
    </Shell>
  );
}
